<template>
  <span>
    <v-card>
      <v-card-text>
        <v-btn icon tag="a" :href="`http://tesseract-ics.herokuapp.com/api/class/${this.$route.params.id}/assignment/download?file_location=${assignment}&token=${this.$store.getters.GET_TOKEN}`" download>
          <v-icon color="blue">file_download</v-icon>
        </v-btn>
        <v-btn icon @click="deleteDialog = true">
          <v-icon color="red">delete</v-icon>
        </v-btn>
        <span>{{assignment}}</span>
        <v-spacer></v-spacer>
      </v-card-text>
    </v-card>

    <v-dialog v-model="deleteDialog" persistent max-width="300">
      <v-card>
        <v-card-title class="headline">Deleting file</v-card-title>
        <v-card-text>
          <p>Are you sure you want to delete this file?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" flat @click="deleteDialog = false" :disabled="loading">Close</v-btn>
          <v-btn 
            dark
            color="red" 
            :loading="loading"
            :disabled="loading"
            @click="deleteFile(file)"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios'
export default {
  props: ['assignment'],
  data(){
    return {
      loading: false,
      deleteDialog: false
    }
  },  
  methods: {
    async downloadFile(file){
      try{
        let res = await axios.post(`/api/class/${this.$route.params.id}/download`, {
          file_location: file
        }, 
        { 
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`
          }
        })
        
      }catch(e){
        console.log(e)
      }
    },
    async deleteFile(file){
      try{
        this.loading = true
        let res = await axios.delete(`/api/class/${this.$route.params.id}/assignments/delete`,
        { 
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`
          },
          params: {
            filenames: [file]
          }
        })
        this.$store.dispatch('admin/FETCH_ASSIGNMENTS', {class_id: this.$route.params.id})
        this.loading = false
        this.deleteDialog = false
      }catch(e){
        this.loading = false
        console.log(e)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Classroom/Assignment.vue